import { axios } from '../../clients/axios'

export default {
  namespaced: true,
  state: {
    forms: []
  },
  getters: {
    getForms: (state) => {
      return state.forms.map((form) => {
        return {
          value: form.formId,
          text: form.formTitle
        }
      })
    }
  },
  mutations: {
    fetchForms: (state, forms) => {
      state.forms = forms
    }
  },
  actions: {
    async fetchFormsAction(context) {
      const forms = await axios.get(`${process.env.VUE_APP_API_URL}/forms`, {
        withCredentials: true
      })
      context.commit('fetchForms', forms.data)

      return forms.data
    },
    async newFormAction(context, params) {
      const { formTitle, formUrl } = params

      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/forms`,
        {
          formTitle,
          formUrl
        },
        { withCredentials: true }
      )

      return response
    },
    async deleteFormAction(context, params) {
      const { formId } = params

      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/forms/${formId}`,
        { withCredentials: true }
      )

      return response
    },
    async updateFormAction(context, params) {
      const { formTitle, formUrl, formId } = params

      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/forms/update`,
        {
          formId,
          formTitle,
          formUrl
        },
        { withCredentials: true }
      )

      return response
    }
  }
}
